import Vue from 'vue'
import VueRouter from 'vue-router';
import * as Cookies from "js-cookie";
import {checkUserPermission} from "../script/helper";

Vue.use(VueRouter)
let token = Cookies.get('token');

const routes = [
  {
    path: '/auth/',
    component: () => import('../layouts/full-page/FullPage.vue'),
    beforeEnter: (to, from, next) => {
      if(token) {
        next({ 
          path: '/',
          // query: { redirect: to.fullPath } 
        })
      } else {
        next()
      }
    },
    children: [
      {
        path: 'login',
        name: 'page-login',
        component: () => import('../views/auth/login/Login.vue'),
      },
      // {
      //   path: 'register',
      //   name: 'page-register',
      //   component: () => import('../views/auth/register/Register.vue'),
      // },
      {
        path: 'forget-password',
        name: 'forget-password',
        component: () => import('../views/auth/forget-password/index.vue'),
      },
    ]
  },
  {
    path: '',
    component: () => import('../layouts/main/Main.vue'),
    beforeEnter: (to, from, next) => {
      if(!token) {
        next({ 
          path: '/auth/login', 
          // query: { redirect: to.fullPath } 
        })
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import ('../views/pages/dashboard/index.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_dashboard')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: '/order-list',
        name: 'order_list',
        component: () => import ('../views/pages/order-list/index.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_order')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: '/order-deatils/:orderId',
        name: 'order_deatils',
        component: () => import ('../views/pages/order-list/OrderDetails.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_order')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: "/create-consignment",
        name: 'create_consignment',
        component: () => import ('../views/pages/consignment/create.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_consignment')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: "/manage-consignment",
        name: "manage_consignment",
        component: () => import ('../views/pages/consignment/ManageConsignment.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_consignment')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: "/manage-reconsignment/:consignmentId",
        name: "manage_reconsignment",
        component: () => import ('../views/pages/consignment/ReConsignment.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_reconciliation')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: "/add-product-category",
        name: "add_product_category",
        component: () => import ('../views/pages/product-categories/AddProductCategory.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_product_category')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: "/edit-product-category/:categoryId",
        name: "edit_product_category",
        component: () => import ('../views/pages/product-categories/EditProductCategory.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_product_category')) {
            next()
          } else {
            next({ 
              path: '/error-404', 
              // query: { redirect: to.fullPath } 
            })
          }
        },
      },
      {
        path: "/manage-categories",
        name: "manage_categories",
        component: () => import ('../views/pages/product-categories/ManageCategory.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_product_category')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-division",
        name: "add_division",
        component: () => import ('../views/pages/division/DivisionCreate.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_division')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/edit-division/:divisionId",
        name: "edit_division",
        component: () => import ('../views/pages/division/DivisionUpdate.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_division')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-division",
        name: "manage_division",
        component: () => import ('../views/pages/division/DivisionManage.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_division')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-area-management",
        name: "add_area_management",
        component: () => import ('../views/pages/area-management/CreateAreaManagement.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_area')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/edit-area-management/:areaId",
        name: "edit_area_management",
        component: () => import ('../views/pages/area-management/EditArea.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_area')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-area-management",
        name: "manage_area_management",
        component: () => import ('../views/pages/area-management/ManageList.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_area')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-zone-management",
        name: "add_zone_management",
        component: () => import ('../views/pages/zone-management/CreateZone.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_zone')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-zone-management",
        name: "manage_zone_management",
        component: () => import ('../views/pages/zone-management/ZoneList.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_zone')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/edit-zone-management/:zoneId",
        name: "edit_zone_management",
        component: () => import ('../views/pages/zone-management/EditZone.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_zone')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-hubs",
        name: "add_hubs",
        component: () => import ('../views/pages/Hubs/CreateHubs.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_hub')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-hubs",
        name: "manage_hubs",
        component: () => import ('../views/pages/Hubs/ManageHubs.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_hub')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/edit-hub/:hubId",
        name: "edit_hub",
        component: () => import ('../views/pages/Hubs/UpdateHub.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_hub')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/company-manage",
        name: "company_manage",
        component: () => import ('../views/pages/company/index.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_company')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/iSMS-manage",
        name: "iSMS_manage",
        component: () => import ('../views/pages/company/ISMS/iSMS.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_sms')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/create-iSMS",
        name: "iSMS_create",
        component: () => import ('../views/pages/company/ISMS/CreateISMS.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_sms')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/update-iSMS/:ismsId",
        name: "iSMS_edit",
        component: () => import ('../views/pages/company/ISMS/UpdateISMS.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_sms')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/isms-message-bodies",
        name: "isms_message_bodies",
        component: () => import ('../views/pages/company/MessageBodies.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_sms')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-role",
        name: "add_role",
        component: () => import ('../views/pages/Roles/CreateRoles.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_role')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-role",
        name: "manage_role",
        component: () => import ('../views/pages/Roles/ManageRoles.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_role')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/update-role/:roleId",
        name: "update-role",
        component: () => import ("../views/pages/Roles/UpdateRoles.vue"),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_role')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-permission",
        name: "add_permission",
        component: () => import ('../views/pages/Permissions/CreatePermissions.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_permission')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-permission",
        name: "manage_permission",
        component: () => import ('../views/pages/Permissions/ManagePermissions.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_permission')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/edit-permission/:permissionId",
        name: "edit_permission",
        component: () => import ('../views/pages/Permissions/UpdatePermission.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_permission')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/add-user",
        name: "add_user",
        component: () => import ('../views/pages/users/CreateUser.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('create_user')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/details-dales-report",
        name: "details_dales_report",
        component: () => import ('../views/pages/report/details_sales_report.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('details_sales_report')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/manage-user",
        name: "manage_user",
        component: () => import ('../views/pages/users/ManageUser.vue'),
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('view_user')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: '/edit-profile',
        name: 'edit_profile',
        component: () => import ('../views/pages/users/LoginUserProfile.vue')
      },
      {
        path: '/edit-user/:userId',
        name: 'edit_user',
        component: () => import ('../views/pages/users/EditUser.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          if(checkUserPermission('update_user')) {
            next()
          } else {
            next({ 
              path: '/error-404',
            })
          }
        },
      },
      {
        path: "/notification-list",
        name: "notification_list",
        component: () => import ('../views/pages/Notification/index.vue'),
      },
      {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('../views/pages/error-pages/404.vue'),
          meta: {
              rule: 'editor'
          }
      },
    ]
  },
  {
    path: '/private-policy',
    name: "privacy_policy",
    component: () => import ('../views/pages/public/index.vue')
  },
  {
    path: '*',
    redirect: '/error-404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

export default router
